import { Box, Button, Card, CardContent, Checkbox, Dialog, IconButton, Input, TextField, Tooltip, Typography } from '@mui/material';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { get, post } from 'api/apiBridges/httpBridge';
import { useSelector } from 'react-redux';
import { loginSelector } from 'store/slices/loginSlice';
import Loading from 'components/Load';
import Scrollbars from 'rc-scrollbars';
import { ReportTable } from 'components/reportTable';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { getDataSource } from 'api/ds';
import { colors } from 'styles/colors';
import { useLocalNotifications } from 'components/Events';
import CountProducts from 'components/widgets/countProducts';
import { DateMenu } from 'components/RangeDate';
import usePreventDoubleClick from 'components/AntiDBC';
import { useNavigate } from 'react-router-dom';
import { useDataContextDeal } from 'actions/contextDealClient';
import { MarketClientSelector } from 'store/slices/marketClient';
import { RestrictedRangePicker } from "components/RangeDate";
import _ from 'lodash';
import ClassicSearch from 'components/classicSearch';
import { format, addDays, startOfDay } from 'date-fns';
import ExcelJS from 'exceljs';
import DownloadIcon from '@mui/icons-material/Download';
import * as XLSX from 'xlsx';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { TemplateExcel } from 'components/excelTemplates';
import { sortProducts } from 'utils/globalSorts';
import { hoverStyle } from "styles/main";

const ClientProductStorage = () => {

    const { user_id, company_id } = useSelector(
        loginSelector
    );
    const { market } = useSelector(MarketClientSelector);

    const [loading, setLoading] = useState(true);
    const [openDialog, setOpenDialog] = useState(false);
    const [data, setData] = useState([]);
    const ds = useMemo(() => {
        const storageName = market === 'custom' 
            ? 'ClientProductsStorageCustom' 
            : 'ClientProductsStorage';
            

        let $ds = getDataSource(storageName)
        console.log('DS DATA',$ds)
        return($ds)
        // return getDataSource(storageName);
    }, [market]);

    

    const [allSKU, setAllSKU] = useState(0)
    const [allProduct, setAllProduct] = useState(0)

    console.log('DATA', data[0]?.data?.market)

    const counttest = () => {
        console.log("test", data)
        let allsku = 0
        let allproduct = 0
        if (data && data.length > 0) {
            allsku = data.length
            for (let i = 0; i < data.length; i++) {
                allproduct += data[i].countProduct;
            }
        }

        setAllSKU(allsku)
        setAllProduct(allproduct)
    }

    useEffect(() => {
        counttest()
    }, [data]);


    //Настройки Фильтра
    const [checked, setChecked] = useState(false);
    const [filter, setFilter] = useState(null);
    const [filterFields, setFilterFields] = useState(
        {
            title: { name: "Название", active: true },
            brand: { name: "Брэнд", active: true },
            vendorCode: { name: "Артикул", active: true },
            barcode: { name: "ШК", active: true },
            color: { name: "Цвет", active: true },
            size: { name: "Размер", active: true },
        }
    );

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);

                let responseData = undefined;

                switch (market) {
                    case "wb":
                        responseData = await get('WBAPI/GetProductStocksInStorage', { uid: user_id });
                        break;
                    case "ozon":
                        responseData = await get('OZONAPI/GetProductStocksInStorage', { uid: user_id });
                        break;
                    case "custom":
                        responseData = await get("custom_product/get_product_stocks_in_storage", {cid:user_id})
                        break;
                }
                
                let res = []
                responseData.map((el) => {
                    if (el.countProduct > 0) {
                        console.log("test 0", el)
                        
                        let err = false//Флаг ошибки
                        el.countInfo = { count: el.countProduct, inBox: el.inbox, err }
                        el.storage_count = el.countProduct
                        el.data.color = el.color
                        el.data.vendorCode = el.vendorCode
                        el.data.sizeTitle = el.size.title
                        el.data.barcode = el.size.barcode
                        console.log("data", el.data)
                        res.push(el)
                    }
                })
                setData(res)
                counttest();
            } catch (err) {
            } finally {
                setLoading(false);
            }


        };

        fetchData();
    }, [market, user_id]);

    const handleExportClick = async (event) => {
        if (event) {
            event.preventDefault(); // Предотвращаем действие по умолчанию
            event.stopPropagation(); // Останавливаем всплытие события
        }
        // 1. Создаем новую книгу и лист
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Мои данные');

        const DataArray = []; // Ваши данные здесь

        let list =[]

        // 2. Определяем заголовки столбцов
        worksheet.columns = [
            { header: 'Имя (необязательно)', key: 'name'},
            { header: 'Артикул', key: 'vendorCode'},
            { header: 'Баркод', key: 'barcode'},
            { header: 'Размер', key: 'size'},
            { header: 'Цвет', key: 'color'},
            { header: 'ТЗ', key: 'techTask'},
            { header: 'Количество', key: 'count'},
        ];

        // 3. Добавляем данные (пример с массивом объектов)
        // Предположим, что `data` - это массив объектов вида {id: 1, name: "Товар 1", quantity: 5}

        for (let product of data) {
            let idx = list.findIndex((fel) => fel.vendorCode === product.size.barcode && fel.techTask === product.size.techTask.version)
            if (idx === -1) {list.push({
                vendorCode: product.data.vendorCode, 
                name: product.data.title, 
                count: product.countProduct,
                techTask: product.size.techTask.version,
                color: product.data.color.join(', '),
                size: product.size.title,
                barcode: product.size.barcode
            })}
            else {list[idx].count += product.countProduct}
        }
        for (let el of list) {
            DataArray.push({vendorCode: el.vendorCode, name:el.name, count:el.count, techTask: el.techTask, color: el.color, size: el.size, barcode: el.barcode})
        }

        worksheet.addRows(DataArray);

        // 4. Генерируем файл как буфер
        const buffer = await workbook.xlsx.writeBuffer();

        // 5. Создаем Blob и скачиваем файл
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        
        // saveAs(blob, 'МойФайл.xlsx');
        

        const blobUrl = URL.createObjectURL(blob);

        // alert('Браузер заблокировал открытие в новой вкладке. Файл будет скачан.');
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = `Файл с товаром ${market}.xlsx`
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Всегда освобождаем память от Blob-URL
        setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);

    }

    //   if (loading) {
    //           return <Loading></Loading>
    //       }

    console.log("DATA", data)

    return (
        <>
            <Dialog
                open={openDialog}
                // maxWidth='lg'
                maxWidth={false}
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setOpenDialog(false) }}
            >
                <div style={{ height: '620px', width: '1420px', padding: '12px' }}>
                    {/* <AddProductToNewDeal data={data} cancel={setOpenDialog} onSave={onAddProduct}></AddProductToNewDeal> */}
                    <AddProductToNewDeal
                        data={data}
                        cancel={setOpenDialog}
                    >
                    </AddProductToNewDeal>
                </div>
            </Dialog>
            <Box sx={{ width: '100%', height: '100%' }}>
                <div style={{ height: "5%", display: 'flex', width: '100%', padding: 'calc(2% - 5px) 1% 1% 1%',  alignItems: 'center', justifyContent: 'space-between' }}>
                    <div style={{display: "flex", flexDirection: 'row', alignItems: 'center'}}>
                        <ClassicSearch
                            setChecked={setChecked}
                            setFilter={setFilter}
                            checked={checked}
                            fields={filterFields}
                            setFields={setFilterFields}
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                        <Box sx={{
                            zIndex: 10,
                            display: 'flex',
                            flexDirection: 'column',
                            backgroundColor: 'rgba(255, 255, 255, 0.5)',
                            padding: '15px 20px',
                            borderRadius: '10px',
                            minWidth: '250px',
                            height: '36px', 
                            justifyContent: 'center'
                        }}>
                            {loading? <Loading></Loading>: 
                            <Box sx={{ display: 'flex', gap: '20px', alignItems: 'center', flexDirection: "row"}}>
                                <Typography sx={{ fontSize: '11pt' }}>
                                    SKU: {allSKU} шт.
                                </Typography>
                                <Typography sx={{ fontSize: '11pt' }}>
                                    Товаров: <Typography component="span" sx={{ fontSize: '11pt', color: 'inherit' }}>{allProduct} шт.</Typography>
                                </Typography>
                                <Tooltip
                                    title={"Скачать список товаров"}
                                >
                                    <IconButton 
                                        onClick={handleExportClick}
                                    >
                                        <DownloadIcon
                                            sx={{
                                                transition: 'all 0.3s ease',
                                                '&:hover': hoverStyle
                                            }}
                                        />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                            }
                        </Box>
                        <Button variant="contained" onClick={() => { setOpenDialog(true) }} sx={{ textTransform: 'none', fontWeight: 'bold', backgroundColor: colors.elements, borderRadius: "10px", width: "150px" }}>{`Новая сделка`}</Button>
                    </div>
                </div>
                <div style={{
                    width: '98%', 
                    height: 'calc(89% + 5px)', 
                    overflow: 'hidden',
                    margin: "1%",
                    borderRadius: "10px"
                }}>
                    {loading? <Loading></Loading>: 
                        <Scrollbars
                            // autoHeight
                            // autoHeightMax={"98%"}
                            style={{ width: '100%', height: '100%', borderRadius: "10px" }} 
                            renderView={({ style, ...props }) => (
                                <div 
                                {...props} 
                                style={{ 
                                    ...style, 
                                    paddingRight: '10px',   // отступ справа под вертикальный скролл
                                    paddingBottom: '10px',   // отступ снизу под горизонтальный скролл
                                    backgroundColor: "#ffffff",
                                }} 
                                />
                            )}
                            // Настройка горизонтального ползунка
                            renderThumbHorizontal={({ style, ...props }) => (
                                <div
                                    {...props}
                                    style={{
                                        ...style,
                                        backgroundColor: "#808080",
                                        height: "10px",
                                        borderRadius: "5px",
                                        cursor: "pointer"
                                    }}
                                />
                            )}
                            renderThumbVertical={({ style, ...props }) => (
                                <div
                                    {...props}
                                    style={{
                                        ...style,
                                        backgroundColor: "#808080",
                                        width: "10px",
                                        borderRadius: "5px",
                                        cursor: "pointer"
                                    }}
                                />
                            )}
                        >
                            <ReportTable
                                ds={ds}
                                data={!checked ? sortProducts(data) : sortProducts(data.filter((el) => {
                                    const tf = filter.toLowerCase();
                                    return (
                                        filterFields.title.active &&
                                            el.data.title &&
                                            String(el.data.title).toLowerCase().includes(tf) ||
                                        filterFields.brand.active &&
                                            el.data.brand &&
                                            String(el.data.brand).toLowerCase().includes(tf) ||
                                        filterFields.vendorCode.active &&
                                            el.vendorCode &&
                                            String(el.vendorCode).toLowerCase().includes(tf) ||
                                        filterFields.barcode.active &&
                                            el.size.barcode && 
                                            String(el.size.barcode).toLowerCase().includes(tf) ||
                                        filterFields.color.active &&
                                            el.color &&
                                            String(el.color.join(" ")).toLowerCase().includes(tf) ||
                                        filterFields.size.active &&
                                            el.size.title &&
                                            String(el.size.title).toLowerCase().includes(tf)
                                    )
                                }))}
                                autoPagination={15}
                            />
                        </Scrollbars>
                    }
                </div>
            </Box>
        </>
    );
};

function AddProductToNewDeal({ data, cancel }) {
    const { user_id } = useSelector(loginSelector);
    const { market } = useSelector(MarketClientSelector);

    const [$data, setData] = useState([]); 
    const [selected, setSelected] = useState([]); 
    const [targetCard, setTargetCard] = useState(null); 
    const [stat, setStat] = useState(undefined); 
    const [multiWay, setMultiWay] = useState([]);

    // Структура кэша: { "nmID": { "YYYY-MM-DD_YYYY-MM-DD": { ...data } } }
    const [statsCache, setStatsCache] = useState({});
    const [statsLoading, setStatsLoading] = useState(false);
    
    // Лимиты
    const [isLimitWaiting, setIsLimitWaiting] = useState(false);
    const [countdown, setCountdown] = useState(0);

    const [dateRange, setDateRange] = useState({
        start: new Date(new Date().setDate(new Date().getDate() - 7)),
        end: new Date()
    });

    const ds = useMemo(() => getDataSource('ProductsForNewDeal'), []);
    const { showNotification } = useLocalNotifications();
    const preventDoubleClick = usePreventDoubleClick();
    const navigate = useNavigate();
    const { setContextData } = useDataContextDeal();

    const [checked, setChecked] = useState(false);
    const [filter, setFilter] = useState(null);
    const [filterFields, setFilterFields] = useState({
        title: { name: "Название", active: true },
        brand: { name: "Брэнд", active: true },
        vendorCode: { name: "Артикул", active: true },
        barcode: { name: "ШК", active: true },
        color: { name: "Цвет", active: true },
        size: { name: "Размер", active: true },
    });

    const getPeriodKey = (start, end) => {
        return `${format(start, 'yyyy-MM-dd')}_${format(end, 'yyyy-MM-dd')}`;
    };

    const handleDateChange = useCallback(([s, e]) => {
        setDateRange({ start: s, end: e });
    }, []);

    const handleRowClick = (item) => {
        if (targetCard?.id !== item.id) {
            setStat(undefined); 
            setTargetCard(item);
        }
    };
    useEffect(() => {
        let timerId;
        if (isLimitWaiting && countdown > 0) {
            timerId = setTimeout(() => setCountdown(c => c - 1), 1000);
        } else if (isLimitWaiting && countdown === 0) {
            setIsLimitWaiting(false);
        }
        return () => clearTimeout(timerId);
    }, [isLimitWaiting, countdown]);

    useEffect(() => {
        let isMounted = true;

        const loadStats = async () => {
            // Если нет товара, юзера или включен режим ожидания лимита — не грузим
            if (!targetCard || !user_id || isLimitWaiting) return;

            const nmID = String(targetCard.nmID);
            const periodKey = getPeriodKey(dateRange.start, dateRange.end);
            
            // Если данные за этот период уже есть в кэше — выходим
            if (statsCache[nmID]?.[periodKey]) {
                return;
            }

            setStatsLoading(true);

            try {
                const res = await post('WBAPI/GetSizeStatsPeriod', {
                    uid: user_id, 
                    nmID: Number(nmID), 
                    startDate: format(dateRange.start, 'yyyy-MM-dd'),
                    endDate: format(dateRange.end, 'yyyy-MM-dd')
                });

                console.log('RESULT', res)

                // Обработка 429
                if (res?.error === "WB_LIMIT_429" || res?.status === 429) {
                    setStatsLoading(false); 
                    setCountdown(20);       
                    setIsLimitWaiting(true); // Включаем таймер, перезапуск случится автоматически
                    return; 
                }

                if (res && !res.error) {
                    // setStatsCache(prev => ({
                    //     ...prev,
                    //     [nmID]: { 
                    //         ...(prev[nmID] || {}), 
                    //         [periodKey]: res // Сохраняем весь ответ под ключом периода
                    //     }
                        
                    // }));
                    let tmp = JSON.parse(JSON.stringify(statsCache))
                    _.set(tmp, `${nmID}.${periodKey}`, res)

                    setStatsCache(tmp)
                }

            } catch (e) {
                console.error("API Fetch Error", e);
            } finally {
                if (isMounted) setStatsLoading(false);
            }
        };

        loadStats();
        return () => { isMounted = false; };
    }, [targetCard?.id, dateRange, user_id, isLimitWaiting]);

    useEffect(() => {
        if (!targetCard) return;

        const nmID = String(targetCard.nmID);
        const periodKey = getPeriodKey(dateRange.start, dateRange.end);
        const periodData = statsCache[nmID]?.[periodKey];
        const selectedSize = String(targetCard.size.title || "").trim().toLowerCase(); 
        console.log('PERIOD', periodData)

        if (periodData) {

            const exactKey = Object.keys(periodData).find(k => k.trim().toLowerCase() === selectedSize);
            const sizeStats = periodData[exactKey];

            console.log('SIZE STATS', sizeStats)
            console.log(selectedSize)
            console.log(exactKey)


            if (sizeStats) {
                setStat({
                    total: targetCard.total || 0,
                    totalInRoad: targetCard.totalInRoad || 0,
                    ordersCount: sizeStats.ordersCount || 0,
                    buyoutCount: sizeStats.buyoutCount || 0,
                    buyoutSum: sizeStats.buyoutSum || 0,
                    buyoutPercent: sizeStats.buyoutPercent || 0,
                    toClientCount: sizeStats.toClientCount || 0,
                    fromClientCount: sizeStats.fromClientCount || 0
                });
            } else {
                setStat(null);
            }
        } else {
             if (!statsLoading && !isLimitWaiting) setStat(null);
        }

    }, [statsCache, dateRange, targetCard, statsLoading, isLimitWaiting]);

    useEffect(() => {
        setData(data.map((el) => ({ ...el })));
    }, [data]);

    const handleFileUpload = (event) => {
        // console.log('uploadPDF', event.target.files, socket.id);
        let file = Array.from(event.target.files)[0];
        if (!file) return;
        
        const reader = new FileReader();
        reader.onload = (e) => {
            // @ts-ignore
            const fileData = new Uint8Array(e.target.result);
            // Чтение рабочей книги из бинарных данных:cite[1]:cite[6]
            const workbook = XLSX.read(fileData, { type: 'array' });
            
            // Получение имени первого листа:cite[1]
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            
            // Преобразование листа в JSON:cite[1]
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            let c1 = undefined
            let c2 = undefined
            let c3 = undefined
            let tmp = undefined
            let seltmp = undefined
            let from_file = undefined
            let count_err = false
            let errBarcodes = []
            switch (market) {
                case 'custom':
                case 'wb':
                    c1 = jsonData
                        .map(row => row[0]) 
                        .filter(value => value !== undefined).splice(1); // Игнорируем пустые ячейки
                    
                    console.log("c1", c1)

                    c2 = jsonData
                        .map(row => row[1]) 
                        .filter(value => value !== undefined).splice(1); 

                    console.log("c2", c2)

                    tmp = JSON.parse(JSON.stringify($data))
                    seltmp = []
                    from_file = []
                    c1.map((el, index) => {
                        let idx = tmp.findIndex((fel) => fel.size.barcode === String(el))
                        if (idx > -1) {
                            let ffidx = from_file.findIndex((fel) => fel.size.barcode === String(el))
                            if (ffidx === -1) {
                                from_file.push({...tmp[idx], countProduct: c2[index]})
                            }
                            else {
                                from_file[ffidx].countProduct += Number(c2[index])
                            }
                            seltmp.push(tmp[idx].id)
                        }
                    })

                    console.log("from_file", from_file)
                    errBarcodes = []
                    count_err = false
                    from_file.map((el) => {
                        let idx = tmp.findIndex((fel) => fel.size.barcode === el.size.barcode)
                        if (el.countProduct > tmp[idx].countProduct) {
                            count_err = true;
                            errBarcodes.push(el.size.barcode)
                        }
                        else {
                            tmp[idx].countProduct = el.countProduct
                            tmp[idx].countInfo.count = el.countProduct
                        }
                    })
                    if (count_err) {
                        showNotification({
                            id: 'err', 
                            type: 'error', 
                            message: `Заявленное количество товара ${errBarcodes[0]} больше, чем есть на хранении` 
                        });   
                        return 
                    }
                    if (seltmp.length === 0) {
                        showNotification({
                            id: 'err', 
                            type: 'error', 
                            message: 'Ни один товар не выбран' 
                        });   
                        return 
                    }

                    setSelected(JSON.parse(JSON.stringify(selected)).concat(seltmp))
                    setData(tmp)
                    showNotification({
                        id: 'err', 
                        type: 'success', 
                        message: `Успешно добавленно товаров: ${seltmp.length}` 
                    });  
                    break
                case 'ozon':
                    c1 = jsonData
                        .map(row => row[2]) //ozonID
                        .filter(value => value !== undefined).splice(1); // Игнорируем пустые ячейки
                    
                    console.log("c1", c1)

                    c2 = jsonData
                        .map(row => row[5]) //count
                        .filter(value => value !== undefined).splice(1); 

                    console.log("c2", c2)

                    c3 = jsonData
                        .map(row => row[1]) //склад
                        .filter(value => value !== undefined).splice(1); 

                    tmp = JSON.parse(JSON.stringify($data))
                    from_file = []
                    seltmp = []
                    let tmpMultiWay = []
                    c1.map((el, index) => {
                        let idx = tmp.findIndex((fel) => fel.size.ozonID === el)
                        if (idx > -1) {
                            tmpMultiWay.push({ozonID: el, barcode:tmp[idx].size.barcode,  warehouse: c3[index], count: c2[index]})

                            //Записываем в отдельный список, так как у нас уже указано количество и получается дубль
                            let ffidx = from_file.findIndex((fel) => fel.size.ozonID === el)
                            if (ffidx === -1) {
                                from_file.push({...tmp[idx], countProduct: c2[index]})
                            }
                            else {
                                from_file[ffidx].countProduct += c2[index]
                            }

                            if (!seltmp.includes(tmp[idx].id)) {seltmp.push(tmp[idx].id)}
                        }
                    })
                    count_err = false
                    errBarcodes = []
                    from_file.map((el) => {
                        let idx = tmp.findIndex((fel) => fel.size.ozonID === el.size.ozonID)
                        console.log("tmp[idx].countProduct", tmp[idx].countProduct)
                        console.log("el.countProduct", el.countProduct)
                        if (tmp[idx].countProduct < el.countProduct) {
                            count_err = true;
                            errBarcodes.push(el.size.barcode)
                        }
                        else {
                            tmp[idx].countProduct = el.countProduct
                            tmp[idx].countInfo.count = el.countProduct
                        }
                    })
                    if (count_err) {
                        showNotification({
                            id: 'err', 
                            type: 'error', 
                            message: `Заявленное количество товара ${errBarcodes[0]} больше, чем есть на хранении` 
                        });   
                        return 
                    }
                    if (seltmp.length === 0) {
                        showNotification({
                            id: 'err', 
                            type: 'error', 
                            message: 'Ни один товар не выбран' 
                        });   
                        return 
                    }

                    setSelected(JSON.parse(JSON.stringify(selected)).concat(seltmp))
                    setData(tmp)
                    setMultiWay(JSON.parse(JSON.stringify(multiWay)).concat(tmpMultiWay))
                    showNotification({
                        id: 'err', 
                        type: 'success', 
                        message: `Успешно добавленно товаров: ${seltmp.length}` 
                    });   
                    break
                default:
                    break
            }
            
        };
        reader.readAsArrayBuffer(file); // Чтение файла как ArrayBuffer:cite[1]:cite[6]
    }

    const goBind = async () => {
        const res = $data.filter(el => selected.includes(el.id) && el.countProduct > 0);
        if (res.length === 0) return;
        let checkList = []
        let err = false
        let errCount = undefined
        for (let p of res) {
            let tmp = `${p.nmID}:${p.size.barcode}`
            if (checkList.includes(tmp)) {
                err = true
                break
            }
            checkList.push(tmp)
            if (p.countProduct > p.storage_count) {
                errCount = `Превышено количество товара ${p.size.barcode}`
                break
            }
        }
        if (err) {
            showNotification({
                id: 'err', 
                type: 'error', 
                message: 'Нельзя выбирать одинаковый товар с разным тезническим заданием' 
            });   
            return
        }
        if (errCount) {
            showNotification({
                id: 'err', 
                type: 'error', 
                message: errCount
            });   
            return
        }
        if (multiWay.length === 0) {setContextData({ deal: res });}
        else {setContextData({ deal: res, multiWay });}
        navigate('deal');
        cancel(false);
    };

    console.log("INFO", selected, $data)

    return (
        <Box sx={{ height: '100%', display: "flex", flexDirection: "column", p: 1, gap: 2, overflow: "hidden" }}>
            <Typography variant="h4" sx={{ fontWeight: "bold" }}>{ds.descr.title}</Typography>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box sx={{ width: "75%", display: "flex", flexDirection: "row", alignItems: "center"}}>
                    <ClassicSearch setChecked={setChecked} setFilter={setFilter} checked={checked} fields={filterFields} setFields={setFilterFields} />
                    <input
                        type="file"
                        accept=".xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        style={{ display: "none" }}
                        id="upload-excel"
                        onChange={handleFileUpload}
                        //disabled={upload}
                    />
                    <Tooltip title="Загрузить из таблицы">
                        <IconButton>
                            <label htmlFor="upload-excel" 
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    margin: 0,
                                    padding: 0,
                                    cursor: 'pointer',
                                }}>
                                <FileUploadIcon
                                    sx={{
                                        transition: 'all 0.3s ease',
                                        '&:hover': hoverStyle
                                    }}
                                />
                            </label>
                        </IconButton>
                    </Tooltip>
                    <TemplateExcel list = {market === 'ozon'? ['simpleTeplateCreateDelivery', 'warehouseTeplateCreateDeliveryOzon'] : ['simpleTeplateCreateDelivery']}/>
                </Box>
                {/* {market === 'wb' && (<RestrictedRangePicker start={dateRange.start} end={dateRange.end} onChange={handleDateChange} formate={undefined} />)} */}
            </Box>

            <div style={{ display: "flex", flexDirection: 'row', height: "100%", overflow: 'hidden' }}>
                <Box sx={{ 
                    flex: 1, 
                    borderRadius: 2, 
                    overflow: 'hidden',
                    '& tr, & .MuiTableRow-root': { 
                        cursor: 'pointer',
                        transition: 'background-color 0.2s',
                        '&:hover': {backgroundColor: '#f5f5f5 !important'}}
                }}>
                    <Scrollbars autoHide>
                        <ReportTable
                            ds={ds}
                            data={!checked ? sortProducts($data) : sortProducts($data.filter((el) => {
                                const tf = filter.toLowerCase();
                                return (
                                    filterFields.title.active &&
                                        el.data.title &&
                                        String(el.data.title).toLowerCase().includes(tf) ||
                                    filterFields.brand.active &&
                                        el.data.brand &&
                                        String(el.data.brand).toLowerCase().includes(tf) ||
                                    filterFields.vendorCode.active &&
                                        el.vendorCode &&
                                        String(el.vendorCode).toLowerCase().includes(tf) ||
                                    filterFields.color.active &&
                                        el.color &&
                                        String(el.color.join(" ")).toLowerCase().includes(tf) ||
                                    filterFields.size.active &&
                                            el.size.title &&
                                            String(el.size.title).toLowerCase().includes(tf) ||
                                    filterFields.barcode.active &&
                                        el.size.barcode && 
                                        String(el.size.barcode).toLowerCase().includes(tf)
                                )
                            }))}
                            onSelect={setSelected}
                            inputSelected={selected}
                            onFormatterChange={(idata) => {
                                let tmp = [...$data];
                                let idx = tmp.findIndex((el) => el.id === idata.row.id);
                                if (idx > -1) { tmp[idx].countProduct = idata.count; setData(tmp); }
                            }}
                            onClickRow={handleRowClick}
                            autoPagination={15}
                        />
                    </Scrollbars>
                </Box>

                {/* ПРАВАЯ КАРТОЧКА */}
                {/* {market === 'wb' && (
                <Card sx={{ borderRadius: 3, boxShadow: 1, ml: 1, width: "200px", background: '#fff', height:'400px' }}>
                    <CardContent sx={{ height: '100%', display: 'flex', flexDirection: 'column', p: 2 }}>
                        
                        {isLimitWaiting ? (
                            <Loading />
                        ) : statsLoading ? (
                            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%', gap: 2 }}>
                                <Loading />
                            </Box>
                        ) : !stat ? (
                            <Box sx={{ textAlign: 'center', mt: 10 }}>
                                <Typography variant="body2" sx={{ opacity: 0.5 }}>
                                    {!targetCard ? "Выберите товар" : "Нет данных за период"}
                                </Typography>
                            </Box>
                        ) : (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                <Typography variant="body2">Размер: <b>{targetCard.size.title}</b></Typography>

                                <hr style={{ width: '100%', opacity: 0.3 }} />
                                
                                <Typography variant="body2">На МП:<b>{stat.total}</b></Typography>
                                <Typography variant="body2">В пути:<b>{stat.totalInRoad}</b></Typography>

                                <hr style={{ width: '100%', opacity: 0.3 }} />

                                <Typography variant="body2">Заказано: <b>{stat.ordersCount} шт.</b></Typography>
                                <Typography variant="body2">Выкуплено: <b>{stat.buyoutCount} шт.</b></Typography>
                                <Typography variant="body2">Выкуп: <b>{stat.buyoutPercent}%</b></Typography>
                                <Typography variant="body2">Сумма: <b>{Number(stat.buyoutSum).toLocaleString()} ₽</b></Typography>

                                <hr style={{ width: '100%', opacity: 0.3 }} />

                                <Typography variant="body2">К клиенту: <b>{stat.toClientCount}</b></Typography>
                                <Typography variant="body2">От клиента: <b>{stat.fromClientCount}</b></Typography>
                            </div>
                        )}
                    </CardContent>
                </Card>)} */}
            </div>

            <Box
                    sx={{
                        display: "flex",
                        gap: 2,
                        width: "100%",
                        justifyContent: 'space-between',
                    }}
                >
                    <Button 
                        onClick={() => cancel(false)}    
                        variant="text" 
                        sx={{ 
                            height: "35px", 
                            width: "150px", 
                            textTransform: 'none', 
                            fontWeight: 'bold', 
                            marginBottom: '10px',
                            marginTop: '10px',
                            fontSize: "20px",
                            borderRadius: "10px"
                        }}
                    >
                        {"Отмена"}
                    </Button>
                    <Button 
                        onClick={preventDoubleClick(goBind, 1000)}
                        variant="contained" 
                        sx={{ 
                            height: "35px", 
                            width: "150px", 
                            textTransform: 'none', 
                            fontWeight: 'bold', 
                            marginBottom: '10px',
                            marginTop: '10px',
                            fontSize: "20px",
                            borderRadius: "10px"
                        }}
                    >
                        Добавить
                    </Button>
                    
                </Box>
        </Box>
    );
}

export default ClientProductStorage;